import { FirebaseService } from './../../providers/firebase.service';
import { Component, Output, Input, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-location-dropdown',
  templateUrl: './select-location-dropdown.component.html',
  styleUrls: ['./select-location-dropdown.component.scss'],
})
export class SelectLocationDropdownComponent implements OnInit, OnChanges {
  locations = [];

  @Output() selectedLocation = new EventEmitter();
  @Input() selectedLocationData: any;
  @Input() clientKey: string;

  constructor(
    public afService: FirebaseService,
  ) { }

  ngOnInit() {
    this.setLocations();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedClientKey']) {
      this.setLocations();
    }
  }

  selectLocation(location) {
    this.selectedLocation.emit(location);
    this.selectedLocationData = location;
  }

  private async setLocations() {
    this.locations = await new Promise<any>(resolve => this.afService.getLocationsByKey(this.clientKey).subscribe(data => resolve(data)));
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/select-location-dropdown/select-location-dropdown.component.ts